//
//
//
//
//
//
//
//
//
//
//
//

import CommonCard from "../CommonCard";
import Tabs from '../Tabs'
export default {
  components: { CommonCard, Tabs },
  data() {
    return {
      tabs: ["总资产", "总负债", "净资产"],
      active: 1,
      options: {},
    };
  },
  mounted() {
    this.options = {
      grid: {
        top: 20,
        bottom: 30,
        left: 29,
        right: 29,
      },
      xAxis: {
        type: "category",
        boundaryGap: ['20%', '20%'],
        data: ["2019年", "2020年", "2021年"],
        axisLabel: {
          color: "#333333",
          fontSize: 12,
          margin: 10
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        }
      },
      yAxis: {
        type: "value",
        axisLabel: {
          color: "#fff",
        },
        splitLine: {
          lineStyle: {
            color: "#EEEEEE",
          },
        },
        axisLine: {
          lineStyle: {
            color: "#EEEEEE",
          },
        },
        axisTick: {
          show: false,
        },
      },
      series: [
        {
          type: "line",
          data: [40, 28, 35],
          symbol: "circle",
          symbolSize: 5,
          label: {
            normal: {
              show: true,
              color: "#333333"
            },
          },
          itemStyle: {
            color: '#FA6669'
          },
          lineStyle: {
            opacity: 0
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#F84252"
                },
                {
                  offset: 0.52,
                  color: "#FF9871"
                },
                {
                  offset: 1,
                  color: "#ffffff"
                },
              ],
              global: false,
            },
          },
        },
      ],
    };
  },
  methods: {
    toggleTab(index) {
      this.active = index;
    },
  },
};
